import { render, staticRenderFns } from "./booking-address.vue?vue&type=template&id=5b9492b6"
import script from "./booking-address.vue?vue&type=script&lang=js"
export * from "./booking-address.vue?vue&type=script&lang=js"
import style0 from "./booking-address.vue?vue&type=style&index=0&id=5b9492b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports